export default {
      id: "member-organization-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#member-organization",
      toString: function () {
        return this.url;
      }
    }